import { render, staticRenderFns } from "./ManagePoll.vue?vue&type=template&id=4818deae"
import script from "./ManagePoll.vue?vue&type=script&lang=js"
export * from "./ManagePoll.vue?vue&type=script&lang=js"
import style0 from "./ManagePoll.vue?vue&type=style&index=0&id=4818deae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports